module.exports = __webpack_public_path__ + "img/first-steps-3-min.c8c630f9.png";